import { api } from '../utils/axios';

// ========================
// HOST APIs
// ========================

/**
 * Fetch all hosts with optional search and pagination
 * @param {string} search - search by hostName or primaryPhone
 * @param {number} page - page number (default 1)
 * @param {number} limit - items per page (default 10)
 */
export const fetchHosts = async (search = '', page = 1, limit = 10) => {
  try {
    const response = await api.get('/hosts', {
      params: { search, page, limit },
    });
    return response.data.data;
  } catch (error) {
    console.error('Error fetching hosts:', error);
    throw error;
  }
};

/**
 * Fetch a single host by ID
 */
export const fetchHostById = async (id) => {
  try {
    const response = await api.get(`/hosts/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching host by ID:', error);
    throw error;
  }
};

/**
 * Create a new host
 */
export const createHost = async (formData) => {
  try {
    const response = await api.post('/hosts', formData);
    return response.data.data;
  } catch (error) {
    console.error('Error creating host:', error);
    throw error;
  }
};

/**
 * Update a host
 */
export const updateHost = async (id, formData) => {
  try {
    const response = await api.patch(`/hosts/${id}`, formData);
    return response.data.data;
  } catch (error) {
    console.error('Error updating host:', error);
    throw error;
  }
};

/**
 * Delete a host
 */
export const deleteHost = async (id) => {
  try {
    const response = await api.delete(`/hosts/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error deleting host:', error);
    throw error;
  }
};

/**
 * Host login
 */
export const hostLogin = async (credentials) => {
  try {
    const response = await api.post('/hosts/login', credentials);
    return response.data.data;
  } catch (error) {
    console.error('Error logging in host:', error);
    throw error;
  }
};
